export default __webpack_public_path__ + "static/media/marketing_iqbr.5e702404.png";